module.exports = __webpack_public_path__ + "static/media/cloudFunctions.7abf1a16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloudFunctions.png
// module id = 753
// module chunks = 1 3